import { CSSInterpolation } from "@emotion/css/dist/declarations/src/create-instance";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Theme } from '@mui/material/styles'
export const TopBarStyle : (theme: Theme) => Record<string, CSSInterpolation> = (theme) => ({
	root: {
		width: '100%',
		// width: 'calc(100% - 211px)',
		textAlign: 'left',
	},
	'@media print': {
		root: {
			display: 'none',
		},
	},

	topBar: {
		backgroundColor: '#fff',
		width: '100%',
		height: '64px',
		borderBottom: '1px solid #e5e5e5',
		paddingLeft: '24px',
		paddingRight: '24px',
	},
	breadcrumbsBox: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	breadcrumbs: {
		'&.MuiBreadcrumbs-root': {
			fontSize: '0.875rem',
		}
	},
	breadcrumbText: {
		'&.MuiTypography-root': {
			fontSize: '0.875rem',
			fontWeight: 500,
		}
	},
	iconBtnReset: {
		'&.MuiIconButton-root': {
			padding: 0,
			margin: 0,
		}
	},
	iconButton: {
		width: '24px',
		height: '24px',
		marginLeft: '16px',
		cursor: 'pointer',
	},
	popoverBox: {
		'& .MuiPopover-paper': {
			borderRadius: '8px',
			boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
			marginTop: '8px',
		}
	},
	popoverContent: {
		padding: '8px',
		minWidth: '120px',
	},
	profileBtn: {
		'&.MuiButton-root': {
			width: '100%',
			justifyContent: 'flex-start',
			padding: '8px 12px',
			borderRadius: '4px',
			textTransform: 'none',
			color: '#333',
			'&:hover': {
				backgroundColor: '#f5f5f5',
			}
		}
	},
	langBtn: {
		'&.MuiButton-root': {
			width: '100%',
			justifyContent: 'flex-start',
			padding: '8px 12px',
			borderRadius: '4px',
			textTransform: 'none',
			color: '#333',
			'&:hover': {
				backgroundColor: '#f5f5f5',
			}
		}
	},
	selectedLangBtn: {
		'&.MuiButton-root': {
			width: '100%',
			justifyContent: 'flex-start',
			padding: '8px 12px',
			borderRadius: '4px',
			textTransform: 'none',
			color: '#008C73',
			backgroundColor: '#f0f9f7',
			'&:hover': {
				backgroundColor: '#e6f4f1',
			}
		}
	},
	iconToggle: {
		width: '40px',
		height: '40px',
		marginRight: '12px',
		cursor: 'pointer',
	},
	topBarTitle: {
		'&.MuiTypography-root': {
			fontSize: '1.25rem',
			fontWeight: 600,
			color: '#333',
		}
	},
	SelectedLanguage :{
		color: (theme as Theme).palette.primary.main,
		backgroundColor: (theme as Theme).palette.action.selected,
		'&:hover': {
			backgroundColor: (theme as Theme).palette.action.selected,
		},
		'& .MuiTypography-root': {
			fontWeight: 600,
		},
	}
});


export const PopoverBox = styled(Stack)({
	gap: 4,
	justifyContent: 'center',
	alignItems: 'center',
	padding: 16,
	minWidth: 200,
	border: '1px solid #ccc',
	borderRadius: 16,
	' button':{
		width: '100%',
		justifyContent: 'center',
		padding: '8px 12px',
		borderRadius: '4px',
		textTransform: 'none',
		'&.ProfileLogout':{
			background: '#555555',
			color: '#fff',
			marginTop: 16,
			width: 200,
		},
	},
	' .ProfileJob':{
		color: '#03bf69',
	},
	' .ProfileNmae':{
		fontWeight: 600,
	},
	' .ProfileSub':{
		color: '#9f9f9f',
	},
});